import { Routes } from '@angular/router';
import { appRouteGuardFn, mustBeLogged } from './shared/services/app-route.guard.fn';
import { inject } from '@angular/core';
import { AppAuthService } from './shared/services/app-auth.service';
import { HomePageComponent } from './app/presentation/pages/home-page/home-page.component';
import { Page404Component } from './app/presentation/pages/common/page-404/page-404.component';
import { PageUnauthorizedComponent } from './app/presentation/pages/common/page-unauthorized/page-unauthorized.component';

export const appRoutes: Routes = [
    {
        title: 'Università LaSapienza - City DB',
        path: 'home',
        component: HomePageComponent,
        canActivate: [],
        children: [
            { path: 'info', loadChildren: () => import('./app/presentation/pages/info/info.routes'), },
            { path: 'unita-stratigrafiche', loadChildren: () => import('./app/presentation/pages/unita-stratigrafiche/unita-stratigrafiche.routes') },
            { path: 'mappe', data: { breadcrumb: 'Mappa' }, loadComponent: () => import('./app/presentation/pages/mappa/mappa.component') },
            { path: 'scavo-3d', data: { breadcrumb: 'Scavo 3D' }, loadComponent: () => import('./app/presentation/pages/scavo/scavo.component') },
            { path: 'museo-virtuale', data: { breadcrumb: 'Museo Virtuale' }, loadComponent: () => import('./app/presentation/pages/museo-virtuale/museo-virtuale.component').then(m => m.MuseoVirtualeComponent) },
            { path: 'galleria-fotografica', data: { breadcrumb: 'Galleria Fotografica' }, loadComponent: () => import('./app/presentation/pages/galleria-fotografica/galleria-fotografica.component').then(m => m.GalleriaFotograficaComponent) },
            { path: 'amministrazione', canActivate: [mustBeLogged], loadChildren: () => import('./app/presentation/pages/account/admin/amministrazione.routes') },
            { path: '', redirectTo: 'info/il-progetto', pathMatch: 'full' },
        ]
    },
    { path: 'notfound', component: Page404Component, title: '404 - Pagina Non Trovata' },
    { path: 'unauthorized', component: PageUnauthorizedComponent, title: 'Accesso non autorizzato' },
    { path: 'account', loadChildren: () => import('./app/presentation/pages/account/account.routes') },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: '**',
        redirectTo: ({ queryParams }) => {
            const authService = inject(AppAuthService);
            if (authService.appSessionService.userInfo) {
                return '/notfound';
            } else {
                return '/home';
            }

        }
    }
];
